import updateEmployeeVpf from './updateEmployeeVpf';
import optOutEmployeeVpf from './optOutEmployeeVpf';

export default {
  updateEmployeeVpf,
  optOutEmployeeVpf,
};